'use strict';

import LabelProperties from './Label';
import ButtonProperties from './Button';
import SiteLocationButtonProperties from './SiteLocationButton';
import DisplayFieldPropertise from './Display_Field';
import TextboxProperties from './Textbox';
import TextareaProperties from './Textarea';
import RichTextAreaProperties from './Rich_Text_Area';
import DropdownProperties from './Dropdown';
import CheckboxProperties from './Checkbox';
import RadioProperties from './Radio';
import DatepickerProperties from './Datepicker';
import TimepickerProperties from './Timepicker';
import MapProperties from './Map';
import ImageProperties from './Image';
import SignatureProperties from './Signature';
import AttachmentProperties from './Attachment';
import LineProperties from './Line';
import LayoutProperties from './Layout';
import TableProperties from './Table';
import RepeatingTableProperties from './Repeating_Table';
import ToggleButtonProperties from './Toggle_Button';
import HyperlinkProperties from './Hyperlink';
import MultiDropdownProperties from './MultiDropdown';
import RatingProperties from './Rating';
import SectionProperties from './Section';
import  InlineAssocFiles from './Inlineassociation';
import  InlineAssocApps from './InlineassociationApps';
import  ViewAssociations from './ViewAssociations';
export {
  LabelProperties,
  ButtonProperties,
  SiteLocationButtonProperties,
  DisplayFieldPropertise,
  TextboxProperties,
  CheckboxProperties,
  DatepickerProperties,
  TimepickerProperties,
  DropdownProperties,
  MultiDropdownProperties,
  ImageProperties,
  MapProperties,
  RadioProperties,
  RichTextAreaProperties,
  TextareaProperties,
  SignatureProperties,
  RepeatingTableProperties,
  AttachmentProperties,
  LineProperties,
  LayoutProperties,
  TableProperties,
  ToggleButtonProperties,
  HyperlinkProperties,
  RatingProperties,
  SectionProperties,
  InlineAssocFiles,
  InlineAssocApps,
  ViewAssociations
};


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Controls.ts